// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
	firebase: {
		"apiKey":							"AIzaSyA_r6BPsRj0vz5aHk3A8-uhod2WurT8leI",
		"authDomain":					"a-ccompany.firebaseapp.com",
		"databaseURL":				"https://a-ccompany.firebaseio.com",
		"projectId":					"a-ccompany",
		"storageBucket":			"a-ccompany.appspot.com",
		"messagingSenderId":	"75911850786"
	},
	studentCreds: {
		email: 'web@user.com',
		password: 'StudentPa55!',
	},
	brand: 'accompany'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
